import React from 'react';
import { NavLink } from 'react-router-dom';
import { Typography } from '@leegality/leegality-react-component-library';
import { iconRenderer, IconKeys, IconColors } from '@components/icon';
import { getTranslation } from '@utils';

const TABS = [
  {
    id: 'consent-preferences',
    labelKey: 'CONSENTS_NAV_LABEL',
    icon: IconKeys.CheckSquare,
    link: 'consent-preferences',
  },
  {
    id: 'requests',
    labelKey: 'REQUESTS_NAV_LABEL',
    icon: IconKeys.FileText,
    link: 'requests',
  },
  {
    id: 'notification-settings',
    labelKey: 'ALERTS_NAV_LABEL',
    icon: IconKeys.Bell,
    link: 'notification-settings',
  },
  {
    id: 'account',
    labelKey: 'ACCOUNT_NAV_LABEL',
    icon: IconKeys.User,
    link: 'account',
  },
];

const BottomNav = () => (
  <nav className="fixed bottom-0 inset-x-0 bg-white border-t border-gray-200 flex items-stretch h-14 z-40 md:hidden">
    {TABS.map((tab) => (
      <NavLink
        key={tab.id}
        to={tab.link}
        className={({ isActive }) => `flex flex-col items-center justify-center gap-0.5 flex-1 no-underline transition-colors ${
          isActive ? 'text-primary-700' : 'text-gray-400 hover:text-gray-600'
        }`}
      >
        {({ isActive }) => (
          <>
            {iconRenderer({
              iconName: tab.icon,
              size: 22,
              color: isActive ? IconColors.PRIMARY : IconColors.GRAY_LIGHT,
            })}
            <Typography
              tag={Typography.Tags.SPAN}
              variant={Typography.Variants.xxs}
              fontWeight={isActive ? Typography.FontWeight.semibold : Typography.FontWeight.medium}
              className="leading-tight"
            >
              {getTranslation(tab.labelKey)}
            </Typography>
          </>
        )}
      </NavLink>
    ))}
  </nav>
);

export default BottomNav;
